import React from 'react';
import { Menu, Tabs, Dropdown } from 'antd';
import { isEmpty, isNil, take, trim, clone } from 'ramda';
import Context from '../Container/Context';
import LinkTo from './LinkTo';
import { asserts, generators } from '../../../utils';

const iconCustomDemand = `${process.env.TARGET}static/imgs/demand.png`;

// 数据倒装， 首页为最后匹配项
const NavMenu = React.memo(({ middleMenuList }) => {
  const { history, memberIsWhite } = React.useContext(Context);
  const [activeKey, setActiveKey] = React.useState('');
  const [topLevelKeys, setTopLevelKeys] = React.useState([]);

  const updateActiveKey = (location, topLevelKeys) => {
    const active = topLevelKeys.find((menuUrl) =>
      location.pathname.includes(take(2, menuUrl.split('/')).join('/')),
    );
    setActiveKey(active);
  };

  React.useEffect(() => {
    // 跳转链接时，监听是否显示头
    const unlisten = history.listen((location) => {
      updateActiveKey(location, topLevelKeys);
    });
    return () => {
      unlisten();
    };
  });

  React.useEffect(() => {
    if (!isEmpty(middleMenuList)) {
      const topKeys = middleMenuList.map(({ menuUrl }) => trim(menuUrl));
      updateActiveKey(history.location, topKeys);
      setTopLevelKeys(topKeys);
    }
  }, [middleMenuList]); // eslint-disable-line

  const handleClick = (menuUrl) => {
    setActiveKey(menuUrl);
  };

  const handleGotoSquare = () => {
    window.open(`https://www.tonggc.com/home`, '_blank');
  };

  const renderMenu = (menuList) => {
    if (asserts.isArray(menuList)) {
      return menuList.map((menu) => {
        const { children, moduName, menuUrl } = menu;
        if (!isEmpty(children) && !isNil(children)) {
          return (
            <Menu.SubMenu
              popupClassName="header-nav-wrapper-sub"
              key={trim(menuUrl)}
              onTitleClick={handleClick}
              title={
                <LinkTo className="display-block" to={trim(menuUrl)} onChange={handleClick}>
                  {moduName}
                </LinkTo>
              }
            >
              {renderMenu(children)}
            </Menu.SubMenu>
          );
        }
        return (
          <Menu.Item key={trim(menuUrl)}>
            <LinkTo className="display-block" to={trim(menuUrl)} onChange={handleClick}>
              {moduName}
            </LinkTo>
          </Menu.Item>
        );
      });
    }
  };

  const renderLinkOrDropdown = (menu) => {
    const { children, moduCode, menuUrl, moduName } = menu;
    if (isEmpty(children) || isNil(children))
      return (
        <Tabs.TabPane
          key={trim(menuUrl)}
          tab={
            !['tongmingSquare', 'customDemand'].includes(moduCode) ? (
              <LinkTo className="display-block" to={trim(menuUrl)} onChange={handleClick}>
                {moduName}
              </LinkTo>
            ) : moduCode === 'customDemand' ? (
              <span className="header-nav-tab-with-icon">
                <img src={iconCustomDemand} alt="" />
                <LinkTo className="display-block" to={trim(menuUrl)} onChange={handleClick}>
                  {moduName}
                </LinkTo>
              </span>
            ) : (
              <LinkTo className="display-block" to={trim(menuUrl)} onChange={handleGotoSquare}>
                {moduName}
              </LinkTo>
            )
          }
        />
      );
    return (
      <Tabs.TabPane
        key={trim(menuUrl)}
        tab={
          <Dropdown
            overlayClassName="header-nav-wrapper-sub"
            overlay={<Menu>{renderMenu(children)}</Menu>}
          >
            <LinkTo className="display-block" to={trim(menuUrl)} onChange={handleClick}>
              {moduName}
            </LinkTo>
          </Dropdown>
        }
      />
    );
  };

  return (
    <nav className="header-nav-wrapper disable-copy">
      <Tabs activeKey={activeKey}>{middleMenuList.map(renderLinkOrDropdown)}</Tabs>
    </nav>
  );
});

export default () => {
  const { middleMenuList, memberIsWhite } = React.useContext(Context);

  const memorizedNavs = React.useMemo(() => {
    if (isEmpty(middleMenuList)) return null;

    if (!isEmpty(middleMenuList)) {
      let newMiddleMenuList = clone(middleMenuList);
      if (!memberIsWhite) {
        // 当前用户是黑名单
        newMiddleMenuList = newMiddleMenuList.map((item) => {
          if (item.moduCode === 'custSo' || item.moduCode === 'custSpecialSo') {
            let children = item.children.filter((item) => item.moduCode !== 'pointOrder');
            return {
              ...item,
              children,
            };
          } else {
            return item;
          }
        });
      }
      return <NavMenu middleMenuList={newMiddleMenuList} />;
    }
  }, [middleMenuList, memberIsWhite]);

  return memorizedNavs;
};
